import { InitOptions } from '@mottu-ops/feature-flag';
import { datadogRum } from '@datadog/browser-rum';
import { DefaultFlags } from './default-flags.utils';
import { ITotem } from '@shared/interfaces';
import { minutesToMilliseconds } from './min-to-ms';
import { environment } from 'environments/environment';

const fetchWithTimeout = (url: string, options: RequestInit, timeout = 5000) => {
	return new Promise((resolve, reject) => {
		const timer = setTimeout(() => reject(new Error('Request timed out')), timeout);
		fetch(url, options)
			.then(response => {
				clearTimeout(timer);
				resolve(response);
			})
			.catch(error => {
				clearTimeout(timer);
				reject(error);
			});
	});
};

export const initConfig = (totem: ITotem): InitOptions => {
	return {
		datadogRum: {
			client: datadogRum,
			trackTraits: true,
		},
		environmentID: environment.flagsmithEnvId,
		identity: totem.branchCode.toString(),
		customAttributes: {
			branchCode: totem.branchCode,
			branchName: totem.name,
			branchId: totem.id,
			branchCountry: totem.country,
		},
		pooling: {
			start: true,
			interval: minutesToMilliseconds(30),
		},
		defaultFlags: DefaultFlags.getDefaultFlags(),
		cacheFlags: true,
		fetch: (url: string, options: RequestInit) => fetchWithTimeout(url, options, 2000),
	};
};
